/**
 * epgTimelineDateContainer.tsx
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const EpgTimelineDateContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: ${86 * Screen.widthRatio}px;
`;

export default EpgTimelineDateContainer;
